// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__laQ3F","name":"Header_name__3beLI","birthday":"Header_birthday__3oj7L","skeleton":"Header_skeleton__3hQ64"};